module.exports = __webpack_public_path__ + "img/icon-pedidos.5168162d.svg";